import { createEntityAdapter } from '@reduxjs/toolkit'

import { RunsheetShift } from '../models/runsheet/RunsheetShift'

export const runsheetShiftsAdapter = createEntityAdapter({
  selectId: (shift: RunsheetShift) => shift.id,
})